import type { MixedCabinDisclaimerProps } from "@b2bportal/core-flights/overridable";
import {
  IconNameEnum,
  useFlightStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import { isMixedCabin } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import { InfoBanner, InfoBannerSeverity } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./styles.module.scss";

const COMPONENT_KEY = CoreFlightsComponent.MixedCabinDisclaimer;

export const MixedCabinDisclaimer = ({
  fareSlice,
  className,
}: MixedCabinDisclaimerProps) => {
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();

  if (!isMixedCabin(fareSlice)) {
    return null;
  }

  return (
    <InfoBanner
      className={clsx(block, className)}
      severity={InfoBannerSeverity.INFO}
      icon={IconNameEnum.info}
    >
      <p className={cn("title")}>{t("mixedCabin.icon")}</p>
      <p className={cn("description")}>{t("mixedCabin.tooltip")}</p>
    </InfoBanner>
  );
};
